import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReactLoading from 'react-loading';
import Box from '@material-ui/core/Box';

import ForgottenButton from './ForgottenButton';

import { SessionContext } from "../context/session-context";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles({
  loadingImg: {
    '& .MuiButton-outlined': {
      
    },
  },
  errorTxt: {
    contrastText: '#ff0000',
    color: '#ff0000'
  },
  txtPadding: {
    width: '310px',
    paddingRight: '10px',
  },
  loginButton: {
    color: '#FFFFFF',
    backgroundColor: '#0C4C35',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#63D764',
    },
    marginTop: 4,
    marginRight: 8,
    padding: '2px 10px 2px 10px',
  },
  menuloginButton: {
    color: '#0C4C35',
    border: '1px solid #0C4C35',
    '&:hover': {
      color: '#63D764',
      border: '1px solid #63D764',
    },
    marginTop: 4,
    padding: '2px 20px 2px 20px',
  },
  containerDiv: {
    width: '100%',
    display:"flex",
    flexDirection:"row",
    justifyContent: "space-around",
    flexWrap:"nowrap",
  },
});

function LoginForm(props) {
  const classes = useStyles();

  const [state, dispatch] = useContext(SessionContext);
  const {onClose, open} = props;
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  
  const handleSubmit = () => {
    setHasError(false);
    setLoading(true);
    setProcessing(true);
  }

  const history = useHistory();
  function handleForgottenClick(e) {
    e.preventDefault();
    history.push("/forgotten-password");
  }

  useEffect(() => {

    if (processing){

      const abortController = new AbortController();
      const request = {   
        name:email,
        password:password
      };

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/login', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        setProcessing(false);
        if (mounted) {
          if (data.status === "success"){
          dispatch({
            type: "create",
            payload: { userid: parseInt(data.uid), aid: parseInt(data.aid), isActive: true, ident: data.ident }
          });
          handleClose();
          } else {
            //Login error.
            switch (data.message){
              default:
              case "login_failed":
                setErrorMsg("Invalid username or password.");
                break; 
              case "company_failed":
                setErrorMsg("Account has been locked. Please contact support on 07904 673 778.");
                break;

            }
            setHasError(true);
            setLoading(false);
          }
        }
      })();
      const cleanup = () => {
         mounted = false;
         abortController.abort();
      };
      return cleanup;
      
    }

  }, [processing]);


  const handleClose = () => {
    onClose(true);
  };

  const handleCloseDialogs = () => {
    onClose(true);
  }

  const handleEnterSubmit = (e) => {
    
    if (e.key === 'Enter') {
      handleSubmit();
      e.preventDefault();
    }
  };

  return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Login</DialogTitle><DialogContent>
              <DialogContentText>
                To login to your account please provide your username and password.
              </DialogContentText>
              <TextField type="email" error={hasError} className={classes.txtPadding} name="email" label="Username" variant="outlined" size="small" margin="dense" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={handleEnterSubmit}required />
              <TextField type="password" error={hasError} name="password" label="Password" variant="outlined" size="small" margin="dense" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={handleEnterSubmit} required />
              {hasError ? ( <DialogContentText><Typography className={classes.errorTxt}>{errorMsg}</Typography></DialogContentText>) : ( '' )}
            </DialogContent>
            {loading ? (
              <div className={classes.containerDiv}>
                <Box p={1} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#63D764"} /></Box>
              </div>
              ) : (
            <DialogActions>
              <div className={classes.containerDiv}>
                <Box p={1} justifyContent="flex-start" flexGrow={1}> <ForgottenButton onClick={handleForgottenClick} /></Box>
                <Box p={1} justifyContent="flex-end"><Button className={classes.loginButton} variant="contained" onClick={handleSubmit} >
                      <Box fontWeight="fontWeightBold" fontSize={16}>Login</Box>
                  </Button>
                </Box>
              </div>
            </DialogActions>
            )}
        </Dialog>
  );
}

export default function LoginDialog(props) {
  const {isLogin, onClose} = props;

  return (
    <div>
      <LoginForm open={isLogin} onClose={onClose} />
    </div>
  );
}